import { useEffect, useState } from "react";
import AutoCredentialsContext from "../context/AutoCredentials";

const AutoCredentialsProvider = ({ children }) => {
  const [autoCredentials, setAutoCredentials] = useState(true);



  return (
    <AutoCredentialsContext.Provider value={{autoCredentials,setAutoCredentials}}>
      {children}
    </AutoCredentialsContext.Provider>
  );
};


export default AutoCredentialsProvider;